import { render, staticRenderFns } from "./CrmDrawer.vue?vue&type=template&id=87a8de26"
import script from "./CrmDrawer.vue?vue&type=script&lang=js"
export * from "./CrmDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports